<script>
  import { Row, Column, Block, Text, Image, Icon } from 'bastone'
  import { colors } from '../consts'
  import { isDesktop } from '../context'

  export let bot = null
  export let showTag = true
  export let width = '15%'
  export let parentWidth = undefined
  export let empty = false
  export let clickFunc = null

  $: realWidth = parentWidth ? calcWidth(parentWidth) : width

  function calcWidth(parentWidth) {
    let result = '15%'
    if (parentWidth >= 1440) {
      result = '13.4%'
    } else if (parentWidth >= 1080) {
      result = '15.8%'
    } else if (parentWidth >= 900) {
      result = '19.2%'
    } else if (parentWidth >= 640) {
      result = '24%'
    } else if (parentWidth >= 400) {
      result = '31%'
    } else {
      result = '47%'
    }
    return result
  }
</script>


<Block
  width={realWidth} minWidth=6rem maxWidth=15rem border=1 cursor=pointer rightMargin=0.4rem bottomMargin=0.4rem 
  borderColor={colors.darkWhite} hoverBgColor={colors.lightWhite} position=relative overflow=hidden
  on:click={clickFunc || (()=>location.href=`/chat?bot_id=${bot.id}`)}
>
  {#if empty}
  <Row height={$isDesktop?'11.1rem':'9rem'} align=center>
    <Icon name=add size=1.3rem bold=1/>
    <Block width=0.2rem/>
    <Text size=1.2rem lineHeight=2rem bold=1>创建</Text>
    <Block width=1rem/>
  </Row>
  {:else}
  <Column expand=1 xAlign=center>
    {#if showTag && bot?.tag }
    <Block 
      backgroundColor={bot.tag=='官方'?colors.black:colors.purple} width=6rem height=1.4rem
      textAlign=center transform=rotate(45deg) position=absolute right=-1.9rem top=0.4rem
    >
      <Text color=white size=0.8rem lineHeight=1.4rem>{bot.tag}</Text>
    </Block>
    {/if}
    <Block height=2rem/>
    <Image height=3rem url={bot?.avatar_url}/>
    <Block height=1rem/>
    <Text size=1.1rem lineHeight=1.2rem bold=1>{bot?.name}</Text>
    {#if $isDesktop }
    <Block height=0.8rem/>
    <Row height=2.2rem overflow=hidden align=center width=86%>
      <Text size=0.8rem lineHeight=1.1rem wrap=1>{bot?.desc}</Text>
    </Row>
    {:else}
    <Block height=0.8rem/>
    {/if}
    <Block height=1rem/>
  </Column>
  {/if}
</Block>